// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"tooltip__fA0hi","pad":"pad__NZ8r6"};